/**
 * Inspire-hub 2 (www.giap.pl)
 *
 * Copyright © GIAP sp.z o.o. All rights reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Karol Pawlak <kpa@giap.pl>, November 2020
 */


import React from 'react';

const buttonPayStyle = {
  borderRadius: 0,
  border: 'none',
  padding: '10px 40px',
  marginLeft: '10px',
  backgroundColor: 'orange',
  color: 'white',
};

// gmina_olesno_powiat_oleski - special case for showing ServiceCardDownloader
// in other districts - do not show
const district_for_cards = ['gmina_olesno_powiat_oleski'];

class ServiceCardDownloader extends React.Component {

  render() {
    return (
      district_for_cards.includes(this.props.prefix) &&
      <a
        className={`btn btn-warning pull-${this.props.position} ${this.props.className}`}
        target="_blank"
        href={`${process.env.API_URL}/eservices/${this.props.prefix}/${this.props.serviceType}/getServiceCard`}
        style={{ ...buttonPayStyle, ...this.props.style }}
      >
        Pobierz kartę e-usługi
      </a>
    );
  }

}

export default ServiceCardDownloader;



// WEBPACK FOOTER //
// src/components/ServiceCardDownloader/ServiceCardDownloader.js